console.log('Hello world!');

// const foo = (a,b) => a*b;

// console.log(foo(2.5,5));
